import { SVGProps } from 'react';

const ListChecks = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="m3 17 2 2 4-4M3 7l2 2 4-4m4 1h8m-8 6h8m-8 6h8"
    />
  </svg>
);
export default ListChecks;
